module.exports = __webpack_public_path__ + "static/GalanoGrotesque-Regular-d23b5ff1b0c439e8ee17014e37fcc3e3.ttf";